module.exports = __webpack_public_path__ + "media/images/btn_book_mare-aea0ffb93b4fdc0be5e4ab14ea0d1374.gif";